export const StrapiAPI = "https://server.awako.ai";
// export const StrapiAPI = "http://localhost:1337";
